import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { StatusSeverity } from '@core/enums/model-status';

export interface ChipCellItem {
	label: string;
	severity?: StatusSeverity;
	tooltip?: string;
}

interface ChipsCellRendererParams extends ICellRendererParams {
	/** Estrae le chips dalla riga; in alternativa il valore della cella può essere un array di ChipCellItem o stringhe */
	chipsGetter?: (data: any) => Array<ChipCellItem | string>;
}

@Component({
	selector: 'core-chips-cell-renderer',
	template: `
		@if (chips.length > 0) {
			<div class="chips-row">
				@for (chip of chips; track chip) {
					<app-tag [value]="chip.label" [severity]="chip.severity" [title]="chip.tooltip || ''"></app-tag>
				}
			</div>
		} @else {
			-
		}
	`,
	styles: [
		`
			.chips-row {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				gap: 4px;
				padding: 6px 0;
				line-height: normal;
			}
		`,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ChipsCellRendererComponent implements ICellRendererAngularComp {
	chips: Array<ChipCellItem> = [];

	agInit(params: ChipsCellRendererParams): void {
		const raw = params.chipsGetter ? params.chipsGetter(params.data) : params.value;
		const items: Array<ChipCellItem | string> = Array.isArray(raw) ? raw : [];

		this.chips = items.map(item =>
			typeof item === 'string'
				? { label: item, severity: 'secondary' as StatusSeverity }
				: { severity: 'secondary' as StatusSeverity, ...item }
		);
	}

	refresh(params: ICellRendererParams): boolean {
		this.agInit(params as ChipsCellRendererParams);
		return true;
	}
}
